enum InteractionType {
  EMAIL = 'email',
  PHONE = 'phone',
  IN_PERSON = 'in_person',
  VIDEO = 'video',
  TEXT = 'text',
  SOCIAL = 'social',
  DIRECT_MAIL = 'direct_mail',
}
export default InteractionType;
